import { createSelector, createStructuredSelector } from '@opengov/compose-app/reselect';
import { getEntity, getEntitySubdomain, getNumericalEntityId } from '@opengov/app-core/entity/selectors';
import { storiesMsgs } from '../../locale';
import { ISetupPdfMessages } from '../../types/setupPDFTypes';

export type IStorySetupPdfProps = {
    entityId: number;
    entityName: string;
    entitySubdomain: string;
    messages: ISetupPdfMessages;
}


export const storySetupPdfProps = createStructuredSelector<any, IStorySetupPdfProps>({
    entityId: getNumericalEntityId,
    entityName: createSelector(getEntity, (entity) => entity.display_name || ''),
    entitySubdomain: getEntitySubdomain,
    messages: createSelector(storiesMsgs, (msgs) => msgs.pdfSetup),
});
